// Quiz definition for the "Test gratuit" — profile neuro-éducatif
// Each option's value scores one of three dimensions:
//   neuro (cognition/attention), stoic (emotion/discipline), system (organisation)
// Score per dimension 0–10. Higher = more friction → bigger opportunity to help.

export const quizQuestions = [
    {
        id: "age",
        category: "Profil",
        question: "Quel est l'âge de votre enfant ?",
        options: [
            { label: "6 à 8 ans", scores: { neuro: 0, stoic: 0, system: 0 }, value: "6-8" },
            { label: "9 à 12 ans", scores: { neuro: 0, stoic: 0, system: 0 }, value: "9-12" },
            { label: "13 à 16 ans", scores: { neuro: 0, stoic: 0, system: 0 }, value: "13-16" },
            { label: "17 à 20 ans", scores: { neuro: 0, stoic: 0, system: 0 }, value: "17-20" },
        ],
    },
    {
        id: "focus",
        category: "Neurosciences",
        question: "Comment évalueriez-vous la concentration de votre enfant sur ses devoirs ?",
        options: [
            { label: "Excellente — il/elle se met seul·e au travail", scores: { neuro: 0 } },
            { label: "Variable selon les jours", scores: { neuro: 1 } },
            { label: "Difficile — il faut beaucoup l'encourager", scores: { neuro: 2 } },
            { label: "Très difficile — c'est un combat quotidien", scores: { neuro: 3 } },
        ],
    },
    {
        id: "screens",
        category: "Neurosciences",
        question: "Combien de temps passe-t-il/elle sur les écrans par jour (hors devoirs) ?",
        options: [
            { label: "Moins d'1 heure", scores: { neuro: 0 } },
            { label: "Entre 1 et 2 heures", scores: { neuro: 1 } },
            { label: "Entre 2 et 4 heures", scores: { neuro: 2 } },
            { label: "Plus de 4 heures", scores: { neuro: 3 } },
        ],
    },
    {
        id: "emotions",
        category: "Stoïcisme",
        question: "Comment gère-t-il/elle ses émotions face à la frustration ?",
        options: [
            { label: "Plutôt bien — il/elle prend du recul", scores: { stoic: 0 } },
            { label: "Cela dépend des contextes", scores: { stoic: 1 } },
            { label: "Difficilement — colère ou pleurs fréquents", scores: { stoic: 2 } },
            { label: "Très difficilement — explosions régulières", scores: { stoic: 3 } },
        ],
    },
    {
        id: "giveup",
        category: "Stoïcisme",
        question: "Que fait-il/elle face à une difficulté (un exercice, un sport...) ?",
        options: [
            { label: "Il/elle persévère naturellement", scores: { stoic: 0 } },
            { label: "Il/elle insiste un peu puis demande de l'aide", scores: { stoic: 1 } },
            { label: "Il/elle abandonne assez vite", scores: { stoic: 2 } },
            { label: "Il/elle évite ce qui semble difficile", scores: { stoic: 3 } },
        ],
    },
    {
        id: "sleep",
        category: "Système",
        question: "Comment se passe le rituel du coucher ?",
        options: [
            { label: "Fluide, sans négociation", scores: { system: 0 } },
            { label: "Quelques résistances de temps en temps", scores: { system: 1 } },
            { label: "Souvent difficile, négociations fréquentes", scores: { system: 2 } },
            { label: "Très difficile — couchers tardifs récurrents", scores: { system: 3 } },
        ],
    },
    {
        id: "mornings",
        category: "Système",
        question: "Et la routine du matin ?",
        options: [
            { label: "Cadrée et sans accroc", scores: { system: 0 } },
            { label: "Bonne, avec quelques ajustements à faire", scores: { system: 1 } },
            { label: "Stressante — il faut sans cesse rappeler les étapes", scores: { system: 2 } },
            { label: "Chaotique — c'est souvent la course", scores: { system: 3 } },
        ],
    },
    {
        id: "autonomy",
        category: "Système",
        question: "À quel point est-il/elle autonome dans son organisation (devoirs, sac, activités) ?",
        options: [
            { label: "Très autonome", scores: { system: 0 } },
            { label: "Plutôt autonome avec un rappel", scores: { system: 1 } },
            { label: "Peu autonome — nécessite un cadre serré", scores: { system: 2 } },
            { label: "Pas autonome du tout", scores: { system: 3 } },
        ],
    },
    {
        id: "confidence",
        category: "Stoïcisme",
        question: "Comment décririez-vous sa confiance en lui/elle ?",
        options: [
            { label: "Solide", scores: { stoic: 0 } },
            { label: "Plutôt bonne, mais fluctuante", scores: { stoic: 1 } },
            { label: "Fragile dans certaines matières/situations", scores: { stoic: 2 } },
            { label: "Faible — il/elle se dévalorise souvent", scores: { stoic: 3 } },
        ],
    },
    {
        id: "potential",
        category: "Neurosciences",
        question: "Avez-vous le sentiment qu'il/elle a un potentiel non-exploité ?",
        options: [
            { label: "Non — il/elle s'épanouit", scores: { neuro: 0 } },
            { label: "Un peu — quelques marges de progression", scores: { neuro: 1 } },
            { label: "Oui, clairement", scores: { neuro: 2 } },
            { label: "Oui — j'ai l'impression qu'il/elle se sous-estime", scores: { neuro: 3 } },
        ],
    },
];

export function scoreQuiz(answers) {
    const totals = { neuro: 0, stoic: 0, system: 0 };
    for (const q of quizQuestions) {
        const idx = answers[q.id];
        if (idx === undefined) continue;
        const opt = q.options[idx];
        if (!opt) continue;
        for (const k of Object.keys(opt.scores || {})) {
            totals[k] = (totals[k] || 0) + (opt.scores[k] || 0);
        }
    }
    // Max possible: neuro=9, stoic=9, system=9 (each on 3 questions × 3)
    const maxes = { neuro: 9, stoic: 9, system: 9 };
    const pct = {
        neuro: Math.round((totals.neuro / maxes.neuro) * 100),
        stoic: Math.round((totals.stoic / maxes.stoic) * 100),
        system: Math.round((totals.system / maxes.system) * 100),
    };
    const global = Math.round((pct.neuro + pct.stoic + pct.system) / 3);
    return { totals, pct, global };
}

export function profileFromScores(score) {
    const g = score.global;
    if (g >= 60) {
        return {
            slug: "structurer",
            title: "Profil à structurer — priorité au cadre",
            headline: "Plusieurs leviers à activer pour libérer le potentiel.",
            tone: "pink",
            description:
                "Votre enfant présente des signaux marqués sur les trois piliers. La bonne nouvelle : la méthode neuro-stoïcienne + Système Familial Haute Performance™ est conçue exactement pour ces situations. Un cadre clair va rapidement faire baisser la tension du quotidien.",
        };
    }
    if (g >= 30) {
        return {
            slug: "developper",
            title: "Profil à développer — un terrain prometteur",
            headline: "De vraies bases, des marges importantes pour grandir.",
            tone: "brand",
            description:
                "Votre enfant a de bons fondamentaux mais quelques zones de friction freinent son plein épanouissement. Avec les bons rituels et outils, vous pouvez débloquer des progrès rapides en quelques semaines.",
        };
    }
    return {
        slug: "potentiel",
        title: "Profil à fort potentiel — entretenir l'élan",
        headline: "Tout est en place — il reste à affiner et accélérer.",
        tone: "brand",
        description:
            "Votre enfant fonctionne très bien. Nos contenus avancés (méta-apprentissage, gestion de la pression, projets long-terme) sont parfaits pour aller chercher l'excellence sans le mettre sous pression.",
    };
}

export function recommendations(score) {
    const recs = [];
    if (score.pct.neuro >= 50) {
        recs.push({
            title: "Réduire l'impact des écrans",
            body:
                "Mettre en place un protocole « écran 3-6-9-12 » et restaurer la plasticité cérébrale en 21 jours.",
            tag: "Neurosciences",
        });
    } else if (score.pct.neuro >= 25) {
        recs.push({
            title: "Booster l'attention en 10 min/jour",
            body:
                "Exercices de neuro-attention courts à intégrer dans la routine de devoirs.",
            tag: "Neurosciences",
        });
    } else {
        recs.push({
            title: "Approfondir le méta-apprentissage",
            body: "Cartes heuristiques avancées et stratégies de mémorisation long-terme.",
            tag: "Neurosciences",
        });
    }

    if (score.pct.stoic >= 50) {
        recs.push({
            title: "Installer la technique STOP",
            body:
                "Méthode stoïcienne pour aider votre enfant à prendre du recul avant de réagir, en 3 étapes.",
            tag: "Stoïcisme",
        });
    } else if (score.pct.stoic >= 25) {
        recs.push({
            title: "Cultiver la dichotomie du contrôle",
            body: "Distinguer ce qui dépend de soi pour bâtir une confiance solide.",
            tag: "Stoïcisme",
        });
    } else {
        recs.push({
            title: "Affiner la maîtrise émotionnelle",
            body: "Journal stoïcien adapté aux ados pour aller plus loin.",
            tag: "Stoïcisme",
        });
    }

    if (score.pct.system >= 50) {
        recs.push({
            title: "Activer le Système Familial Haute Performance™",
            body:
                "Cadrer routines matin/soir, environnement et règles d'autonomie — pour éliminer le chaos.",
            tag: "Organisation",
        });
    } else if (score.pct.system >= 25) {
        recs.push({
            title: "Optimiser la routine du soir",
            body: "Rituel apaisant + préparation du lendemain pour un coucher fluide.",
            tag: "Organisation",
        });
    } else {
        recs.push({
            title: "Passer au niveau supérieur d'autonomie",
            body: "Système de responsabilités partagées et objectifs hebdomadaires.",
            tag: "Organisation",
        });
    }

    return recs;
}
